import { render, staticRenderFns } from "./AppDetailedView.vue?vue&type=template&id=7c566a37&scoped=true"
import script from "./AppDetailedView.vue?vue&type=script&lang=ts"
export * from "./AppDetailedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c566a37",
  null
  
)

export default component.exports